// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"PlantSelectorDropdown_dropdown__1UeNv","dropdownDark":"PlantSelectorDropdown_dropdownDark__28HDh","select":"PlantSelectorDropdown_select__3l8l8"};